import React from 'react';
import './Home1.css'
const Home1 = () => {
    return (
        <div className='Home1' id='Home'>
             <p className='titl'>
                        Hello, Welcome
                    </p>
                    <h1 className='app-head'>
                        Hi, I&#39;m <span className='nam'> Sri Ram Mathala</span>
                    </h1>
                    <h1 className='app-hea'>A Front End Web Developer</h1>
                    <p className='app-p'>
                        I’m focused on building responsive  web applications <p className='teb'>while
                        learning & exploring other technologies.
                            </p>
                    </p>
        </div>
    );
};

export default Home1;